import * as React from 'react';
import { Link } from 'react-router-dom';
import actionTypes from '../../../../actions/ActionTypes';
import { LoadDefaults } from '../../../../actions/DefaultActions';
import DefaultsStore from '../../../../stores/DefaultsStore';

class DefaultSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);

    this.state = {
      defaultsList: [],
      currentDefault: undefined,
    };

    this.onDefaultChange = this.onDefaultChange.bind(this);
  }


  componentDidMount() {

    DefaultsStore.addChangeListener(this.onDefaultChange);
   // let list = DefaultsStore.getDefaults();
    //if (list === undefined) {
      LoadDefaults();
    // } else {
    //   this.setState({ defaultsList: list });
    // }
  }

  componentWillUnmount() {
    DefaultsStore.removeChangeListener(this.onDefaultChange);
  }

  onDefaultChange() {
    let lastChange = DefaultsStore.getLastAction();
    if(lastChange === actionTypes.GetDefaults)
    {
      let list = DefaultsStore.getDefaults();
      this.setState({ defaultsList: list });
    }
    if (lastChange === actionTypes.DefaultDelete)
    {
      let list = DefaultsStore.getDefaults();
      console.log(list);
      this.setState({ defaultsList: list });
    }
  }

  render() {
    let listOfDefaults;
    if (this.state.defaultsList !== undefined) {
        listOfDefaults = this.state.defaultsList.map((defaults) => (
        <Link
          className='sidebar-link'
          to={'/Admin/Defaults/' + defaults.defaultsDBId}
          key={defaults.defaultsDBId}
          //onClick={() => this.handleBPClick(bp)}
          style={{ cursor: 'Pointer' }}
        >
          <span>
            <i
              className='fa-solid fa-right-from-bracket'
              style={{ color: '#6CB5D0' }}
            />
            {'   '}
            {defaults.defaultName}
          </span>
        </Link>
      ));
    } else {
        listOfDefaults = <div />;
    }

    return (
      <div
        className='d-flex flex-column p-3 text-white bg-dark'
        style={{ height: '100%', width: '245px' }}
      >
        <Link
          to='/Admin/Defaults'
          className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
        >
          <span className='fs-4'>
            Defaults
          </span>
        </Link>
        <hr />
        {listOfDefaults}
        <hr />

        <Link to='/Admin/Defaults/new' className='sidebar-link'>
          New Default
        </Link>
        <hr />



      </div>
    );
  }
}

export default DefaultSidebar;
